import { Analytics } from '@segment/analytics-next';
import { ActionMenuItem } from '../../commons/components/GrowegyMenu';
import { BookIcon } from '../../assets/icons';
import { openUrlInNewTab } from '../../util/window-utils';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const createTutorialsMenuItem = (
  isHidden: boolean,
  analytics?: Analytics,
  dataTest?: string
): ActionMenuItem => ({
  type: 'standard',
  text: 'Tutorials',
  icon: <BookIcon />,
  isHidden,
  dataTest,
  onClick: () =>
    openUrlInNewTab('https://www.growegy.com/resources/', {
      analytics,
      analyticsEvent: AnalyticsEvent.TUTORIALS_OPENED,
    }),
});
